/* eslint-disable */

import axios from "axios";
import store from "../../store/index";
import moment from "moment";
export default {
  name: "manageSubjectModal",
  props: { patientId: String },
  async mounted() {
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    };
    document.body.style.overflowY = "hidden"
    this.values.language = "English"
    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.setstudyid();
      this.getStudyDetails();
      this.getLanguage();
      this.getCountries();
      this.getsites();
      this.getStudyArms();
      this.IsVsitCreated();
    });

    await this.setstudyid();
      await Promise.all([
    this.getLanguage(),
    this.getCountries(),
    this.getsites(),
    this.getUsers(),
    this.getSubjectStatus(),
    this.getSubjectMilestones()
  ]);
    await this.getStudyDetails();
    await this.getStudyArms();
     this.getCohortList();
    await this.IsVsitCreated();
    await this.getPatientSchedule();
    this.mapScheduleToVisits();
    this.setSelectedPhasesFromSchedule();
    this.getLanguage();
    this.getCountries();
    this.getsites();
    this.getUsers();
    this.getSubjectStatus();   
    this.getSubjectMilestones();
    const today = this.getTodayDate();

    if (this.patientId != 0) {
      await this.getPatient(this.patientId);
      await this.getPatientSchedule();
      this.originalEnrollmentDate = this.values.enrollmentDate;
      this.setSelectedPhasesFromSchedule();
      // this.mapScheduleToVisits(); 

      //   this.visits.forEach(v => {
      //   if (!v.plannedDate) {
      //     v.plannedDate = today;
      //   }
      // });
    }
  },
  async unmounted() {
    document.body.style.overflowY = "auto"
  },
  computed: {
    phaseOptions() {
      const phases = [
        ...new Set(
          this.visits
            .map(v => v.studyPhase)
            .filter(p => p && p.trim() !== "")
        )
      ];

      return phases.map(p => ({
        label: p,
        value: p
      }));
    },
    groupedVisits() {
      const map = {};

      this.visits.forEach(v => {
        if (!v.studyPhase) return;

        if (!map[v.studyPhase]) {
          map[v.studyPhase] = [];
        }
        map[v.studyPhase].push(v);
      });

      return map;
    }
  },
  data() {
    return {
      sites: "",
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patient/`,
      baseapi: process.env.VUE_APP_Service_URL,
      token: store.getters.getIdToken,
      isSaving: false,
      head: {},
      maxLength: 1000,
      maxZip: 1000,
      countries: [],
      languages: [],
      users: [],
      isSchedule: false,
      isPhaseLoading: true,
      createdPatientId: "",
      sectionState: {
        basic: true,
        consent: true,
        phases: true,
        enrollment: true,
        cohort: true
      },
      visits: [
      ],
      originalVisitDates: {},
      originalEnrollmentDate: null,
      values: {
        patientId: "",
        isScreeningFailed: false,
        screeningFailureReason: "",
        siteCode: "",
        siteId: "",
        accountId: "",
        studyId: "",
        subjectId: "",
        enrollmentDate: "",
        status: "",
        patientNotes: "",
        active: true,
        languageCode: "",
        patientNo: "",
        country: "",
        nurseName: "",
        preVisit: 0,
        postVisit: 0,
        city: "",
        zipCode: "",
        language: "",
     
        isSchedule: false,
        armCode: "",
        screeningDate: null,
        status: "",
        milestone: "",
        isScreening: false,
        isConsentSigned: false,
        consentSignedDate: null,
        milestoneupdatedAt: null,
        cohortId: "",
        cohortName: "",
        cohortCode: "",

      },
      patientSchedule: [],
      showMandatory: false,
      validations: [true, true, true, true, true, true],
      errors: [],
      isVisitCreated: 0,
      armList: [],
      selectedArm: "",
      studyDetails: {},
      studyId: store.getters.getStudyIs,
      isArmSpecific: false,
      statusList: [],
      cohortList: [],
      milestoneList: [],
      selectedPhases: [],
      studySoAId: null,

    };
  },
watch: {
  async "values.armCode"(val) {

    if (this.values.cohortId) {
      await this.IsVsitCreated();
      return;
    }

    if (val) {
      await this.IsVsitCreated();
    }
  },

  async "values.cohortId"(newVal) {

    const selected = this.cohortList.find(c => c.id === newVal);

    if (selected) {
      this.values.cohortName = selected.cohortName;
      this.values.cohortCode = selected.cohortCode;
    } else {
      this.values.cohortName = "";
      this.values.cohortCode = "";
    }

    await this.IsVsitCreated();
  },
},
  methods: {
    hasEnrollmentDateChanged() {
      const original = this.originalEnrollmentDate || null;
      const current = this.values.enrollmentDate || null;

      return original !== current;
    },
    handleCheck(e) {
      if (e.target.checked === true) {
        this.showMandatory = true;

        if (!this.values.enrollmentDate) {
          this.values.enrollmentDate = this.getTodayDate();
        }

      } else {
        this.showMandatory = false;

        this.values.enrollmentDate = "";
      }
    },
    closeModal() {
      this.validations = [true, true, true, true, true, true];
      this.errors = [];
      this.$emit("closeModal")
    },
    async setstudyid() {
      this.values.studyId = store.getters.getStudyIs;
    },
    getTodayDate() {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    // async IsVsitCreated() {
    //   const currentstudy = store.getters.getStudyIs;
    //   const idtoken = store.getters.getIdToken;
    //   this.isPhaseLoading = true;
    //   await axios
    //     .get(
    //       `${this.baseapi}/management/visit/listvisit?StudyId=${currentstudy}&SortProperty=visitOrder`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       this.isVisitCreated = res.data.totalCount;
    //       this.visits = res.data.results;
    //     })
    //     .catch((err) => console.log("error...", err))
    //     .finally(() => {
    //       this.isPhaseLoading = false;
    //     });
    // },
    async IsVsitCreated() {
      const idtoken = store.getters.getIdToken;
      this.isPhaseLoading = true;

      const params = this.getEffectiveVisitParams();

      let query = `StudyId=${params.studyId}&SortProperty=${params.sortProperty}`;

      if (params.soaId) {
        query += `&SoAId=${params.soaId}`;
      } else if (params.armCode) {
        query += `&ArmCode=${params.armCode}`;
      }

      try {
        const res = await axios.get(
          `${this.baseapi}/management/visit/listvisit?${query}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.isVisitCreated = res.data.totalCount;
        this.visits = res.data.results;
        this.selectedPhases = [];
        this.originalVisitDates = {};
        this.patientSchedule = [];
      } catch (err) {
        console.log("error...", err);
      } finally {
        this.isPhaseLoading = false;
      }
    },
    async saveOrEditPatient() {
      await this.validateIsNull();

        if (this.validations.includes(false) || this.errors.includes("visitDate")) {
        return;
      }

      // language mapping
      if (this.values.language) {
        const lang = this.languages.find(
          item => this.values.language === item.language
        );
        if (lang) {
          this.values.languageCode = lang.code;
        }
      }

      if (this.patientId != 0) {
        this.editPatient();
      } else {
        this.savePatient();
      }
    },
    async changeSiteStatus() {
      const idtoken = store.getters.getIdToken;
      if (this.values.isSchedule == true) {
        await axios
          .put(
            `${this.baseapi}/management/site/changesitestatus?siteId=` + this.siteId +
            `&status=Enrolled`, {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => { console.log("site status changed successfully...!", res); })
          .catch((err) => { console.log(err); });
      }
      else {
        await axios.put(`${this.baseapi}/management/site/changesitestatus?siteId=` + this.values.siteId + `&status=New`, {},
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => { console.log("site status changed successfully...!") })
          .catch((err) => { console.log(err); console.log("error in change site status...!") })
      }
    },
    async getsites() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(`${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudy}&getAll=false`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.sites = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getSubjectStatus() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(`${this.baseapi}/management/statusmaster/getall?StatusType=Subject`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.statusList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCohortList() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      await axios
        .get(`${this.baseapi}/management/cohort/search?StudyId=${studyId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.cohortList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getLanguage() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/forms/template/languages`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {

          this.languages = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCountries() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/management/patient/getallcountry`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.countries = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getUsers() {
  const idtoken = store.getters.getIdToken;
  try {
    // Fetch only users with role "Investigator"
    const response = await axios.get(
      `${this.baseapi}/account-core/user/userlist?Role=Investigator&pageindex=1&pagesize=1000`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    // Map to the structure used in the template
    this.users = response.data.results.map(user => ({
      userID: user.id,               // for :key
      email: user.emailIdPrimary,    // for :value (v-model)
      name: user.fullName            // for display
    }));
  } catch (err) {
    console.error('Error fetching investigators:', err);
    this.users = [];
  }
},
    // async getUsers() {
    //   const valnow = await store.getters.getStudyIs;
    //   const idtoken = store.getters.getIdToken;
    //   console.log("get recipients" + valnow);
    //   await axios
    //     .get(
    //       `${this.baseapi}/management/study/getusersinstudy?StudyId=${valnow}`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       this.users = res.data;
    //       console.log("Users......", this.users);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    async getPatient(patientId) {
      const idtoken = store.getters.getIdToken;
      console.log("in getPatient");
      await axios
        .get(this.baseUrl + "getpatientbyid/" + patientId, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.isSchedule = ""
          this.values = res.data
          console.log("the values are", this.values)
          this.isSchedule = this.values.isSchedule
          if (this.values.country) {
            this.countries.filter((item) => {
              if (this.values.country == item.code) {
                this.values.country = item.name
              }
            });
          }
          this.values.consentSignedDate = this.toDatePickerValue(this.values.consentSignedDate);
          this.values.screeningDate = this.toDatePickerValue(this.values.screeningDate);
          if (this.values.screeningDate && this.values.screeningDate !== "") {
            this.values.isScreening = true;
          } else {
            this.values.isScreening = false;
          }
        })
        .catch((err) => console.log(err));
      console.log("value.data", this.values);
    },
    async editPatient() {
      const idtoken = store.getters.getIdToken;
       this.isSaving = true;
      this.values.patientId = this.patientId;

      const payload = { ...this.values };
      payload.consentSignedDate = payload.consentSignedDate
        ? payload.consentSignedDate
        : null;

      payload.screeningDate = payload.screeningDate
        ? payload.screeningDate
        : null;

      try {
        const res = await axios.put(
          this.baseUrl + "updatepatient",
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        let visitIdsToSkip = [];

        const changedVisits = this.getChangedVisits();

        if (changedVisits.length > 0) {
          console.log("Only changed visits → updating schedule");

          visitIdsToSkip = await this.createPhaseVisits(
            this.patientId,
            changedVisits
          );
        }
        const isEnrollmentChanged = this.hasEnrollmentDateChanged();
        if (this.values.isSchedule && isEnrollmentChanged) {
          await this.postSchedule(this.patientId, visitIdsToSkip);
        }

        this.changeSiteStatus();

        alert(this.$t('navigations.subject updated successfully'));
        this.closeModal();

      } catch (err) {
        console.log("update err reponse: ", err);

        if (err.response.data.detail[0].includes("Subject ID already exists.")) {
          alert(this.$t('navigations.subject id already exists'));
        }
      }
      finally {
    this.isSaving = false;
  }
    },
    async savePatient() {
  const idtoken = store.getters.getIdToken;
  this.isSaving = true;
  try {
    const res = await axios.post(
      this.baseUrl + "createpatient",
      this.values,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    this.createdPatientId = res.data;

    let visitIdsToSkip = [];

        if (this.selectedPhases.length) {
          const visitDetails = this.getSelectedPhaseVisits();
          visitIdsToSkip = await this.createPhaseVisits(this.createdPatientId,visitDetails);
        }

    if (this.values.isSchedule) {
      await this.postSchedule(this.createdPatientId, visitIdsToSkip);
    }

    this.changeSiteStatus();
    alert(this.$t('navigations.subject added successfully'));
    this.$emit("closeModal");

  } catch (err) {
    console.log(err);
    if (err?.response?.data?.detail === "Subject ID already exists.") {
      alert(this.$t('navigations.subject id already exists'));
    }
  } finally {
    this.isSaving = false;
  }
},
    // async savePatient() {
    //   const idtoken = store.getters.getIdToken;

    //   try {
    //     const res = await axios.post(
    //       this.baseUrl + "createpatient",
    //       this.values,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     this.createdPatientId = res.data;

    //     let visitIdsToSkip = [];

    //     if (this.selectedPhases.length) {
    //       visitIdsToSkip = await this.createPhaseVisits(this.createdPatientId);
    //     }

    //     if (this.values.isSchedule) {
    //       await this.postSchedule(this.createdPatientId, visitIdsToSkip);
    //     }

    //     this.changeSiteStatus();
    //     alert(this.$t('navigations.subject added successfully'));
    //     this.$emit("closeModal");

    //   } catch (err) {
    //     console.log(err);
    //     if (err?.response?.data?.detail === "Subject ID already exists.") {
    //       alert(this.$t('navigations.subject id already exists'));
    //     }
    //   }
    // },
    getSelectedPhaseVisits() {
      return this.visits
        .filter(v =>
          this.selectedPhases.includes(v.studyPhase) &&
          v.plannedDate
        )
        .map(v => ({
          visitId: v.visitId,
          visitDate: new Date(v.plannedDate).toISOString()
        }));
    },
    async postSchedule(patientId, visitIdsToSkip = []) {
      const idtoken = store.getters.getIdToken;
      const valnow = store.getters.getStudyIs;
      axios
        .post(
          `${this.baseapi}/management/patientschedule/schedule`,
          {
            studyId: valnow,
            patientId: patientId,
            visitIdsToSkip: visitIdsToSkip
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
            },
          }
        )

        .then((res) => {
          this.changeSiteStatus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearForm() {
      console.log("form cleared");
      this.values.country = "";
      this.values.nurseName = "";
      this.values.city = "";
      this.values.zipCode = "";
      this.values.armCode = "";
      this.values.patientNotes = "";
      this.values.status = "";
      this.values.screeningFailureReason = "";
      this.values.isScreeningFailed = false;
      this.values.isConsentSigned = false;
      this.values.consentSignedDate = null;
      this.values.screeningDate = null;
      this.values.isScreening = false;
      this.values.language = "English";
      this.values.languageCode = "en";
      this.values.milestone = "";
      this.values.active = true;
      this.values.cohortId = "";
      this.values.cohortName = "";
      this.values.cohortCode = "";
      if (this.patientId == 0 || this.patientId == "0") {
        this.values.siteId = "";
        this.values.subjectId = "";
        this.values.enrollmentDate = "";
        this.values.postVisit = 0;
        this.values.preVisit = 0;
        this.values.isSchedule = false;
      }
    },
    async onclosed() {
      this.$router.push(`/patientList`);
    },
    async validateIsNull() {
      // reset first
      this.validations = [true, true, true, true, true, true];
      this.errors = [];


      this.values.subjectId = this.values.subjectId.replace(/ +/g, ' ').trim();

      // Site Code
      if (!this.values.siteId) {
        this.validations[0] = false;
      }

      if (!this.values.subjectId) {
        this.validations[1] = false;
      }

      if (this.showMandatory && !this.values.enrollmentDate) {
        this.validations[2] = false;
      }

     if (false && this.isArmSpecific && !this.values.armCode)

      if (this.selectedPhases.includes("Screening")) {
        if (!this.values.screeningDate) {
          this.validations[4] = false;
        }
      } else {
        this.validations[4] = true;
      }

      if (this.values.isConsentSigned && !this.values.consentSignedDate) {
        this.validations[5] = false;
      }

      // phase null validation 
      let hasVisitError = false;

      this.visits.forEach(v => {
        if (
          this.selectedPhases.includes(v.studyPhase) &&
          !v.plannedDate
        ) {
          hasVisitError = true;
        }
      });

      if (hasVisitError) {
        this.errors.push("visitDate"); // flag for UI
      }
    },
    async numberonlyvalidation(fieldname) {
      let isNumber = true;
      this.values[fieldname] = this.values[fieldname].replace(/\s/g, '');
      let fieldval = this.values[fieldname];
      console.log("valtttttt is", fieldval);
      if (fieldval % 1 != 0) {
        isNumber = false;
      }
      console.log(this.values[fieldname]);
      console.log(isNumber);
      if (!isNumber) {
        this.values[fieldname] = 0;
      }
      else {
        if (parseInt(this.values[fieldname]) >= 0) {
        }
        else {
          this.values[fieldname] = 0;
        }
      }
    },
    handleConsentCheck() {
      if (!this.values.isConsentSigned) {
        this.values.consentSignedDate = null;
      }
    },
    async getStudyArms() {
      const studyId = store.getters.getStudyIs;
      try {
        const response = await axios.get(
          `${this.baseapi}/fhir-service/arm/getarmsbystudyid?study_id=${studyId}`, this.head
        );
        console.log("Study Arms Response:", response.data);
        this.armList = response.data;
      }
      catch (error) {
        console.error("Error fetching Study Arms:", error);
      }
    },
    async getStudyDetails() {
      try {
        const response = await axios.get(`${this.baseapi}/management/study/getbyid?id=${this.studyId}`, this.head)

        this.studyDetails = response.data;

        const currentVersion = this.studyDetails.currentVersion;
        const versionObj = this.studyDetails.versions.find(
          v => v.version === currentVersion
        );

        this.isArmSpecific = versionObj ? versionObj.isArmSpecific : false;
        this.studySoAId = versionObj ? versionObj.soaId : null;
      }
      catch (error) {
        console.error("error in get study", error);
      }
    },
    onScreeningDateChange() {
      if (this.values.screeningDate !== "") {
        this.values.isScreening = true;
      }
    },

    handleScreeningCheck() {
      if (this.values.isScreening) {
        const today = this.getTodayDate();

        this.visits = this.visits.map(v => ({
          ...v,
          plannedDate: v.plannedDate || today
        }));

      } else {
        this.values.screeningDate = null;

        this.visits = this.visits.map(v => ({
          ...v,
          plannedDate: null
        }));
      }
    },
    async getSubjectMilestones() {
      try {
        const response = await axios.get(
          `${this.baseapi}/management/patient/listsubjectmilestone?studyId=${this.studyId}`, this.head
        );

        console.log("Milestones:", response.data);
        this.milestoneList = response.data.data || [];
      } catch (error) {
        console.error("Error fetching milestones:", error);
      }
    },
    toggleSection(section) {
      this.sectionState[section] = !this.sectionState[section];
    },
    async createPhaseVisits(patientId,visitDetails = []) {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      const payload = {
        studyId: studyId,
        patientId: patientId,
        visitDetails: visitDetails
      };

      try {
        const res = await axios.post(
          `${this.baseapi}/management/patientschedule/createvisitbasedschedule`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Screening visits created", res.data);


        return visitDetails.map(v => v.visitId);

      } catch (err) {
        console.error("Error creating screening visits", err);
        return [];
      }
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
    toDatePickerValue(dateString) {
      if (!dateString) return null;
      return moment.utc(dateString).format("YYYY-MM-DD");
    },
    async getPatientSchedule(patientId) {
      const idtoken = store.getters.getIdToken;

      try {
        const response = await axios.get(
          `${this.baseapi}/management/patientschedule/getpatientshedule?patientID=${this.patientId}&ItemCount=500&sortprop=VisitNo`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.patientSchedule = response.data.data || [];

      } catch (error) {
        console.error("Error fetching patient schedule:", error);
      }
    },
    mapScheduleToVisits() {
      if (!this.patientSchedule?.length || !this.visits?.length) return;

      const original = {};

      this.visits = this.visits.map(v => {
        const matched = this.patientSchedule.find(
          s =>
            String(s.visitNo) === String(v.visitNo) &&
            s.studyPhase === v.studyPhase
        );

        const plannedDate = matched
          ? moment.utc(matched.visitDate).format("YYYY-MM-DD")
          : v.plannedDate || null;

        // store original
        original[v.visitId] = plannedDate;

        return {
          ...v,
          plannedDate
        };
      });

      this.originalVisitDates = original;
    },
    hasVisitDateChanged() {
      return this.visits.some(v => {
        const original = this.originalVisitDates[v.visitId] || null;
        const current = v.plannedDate || null;

        return original !== current;
      });
    },

    onPhaseToggle(phase) {
      const today = this.getTodayDate();

      // this.visits.forEach(v => {
      //   if (v.studyPhase === phase && !v.plannedDate) {
      //     v.plannedDate = today;
      //   }
      // });
    },
    setSelectedPhasesFromSchedule() {
      if (!this.patientSchedule?.length) return;

      const phases = [
        ...new Set(this.patientSchedule.map(s => s.studyPhase))
      ];

      this.selectedPhases = phases;
    },
    getChangedVisits() {
      return this.visits
        .filter(v => {
          const original = this.originalVisitDates[v.visitId] || null;
          const current = v.plannedDate || null;

          return (
            this.selectedPhases.includes(v.studyPhase) &&
            current && // only valid dates
            original !== current
          );
        })
        .map(v => ({
          visitId: v.visitId,
          visitDate: new Date(v.plannedDate).toISOString()
        }));
    },
    getEffectiveVisitParams() {
      let params = {
        studyId: this.studyId,
        sortProperty: "visitOrder"
      };

      // ARM SPECIFIC STUDY
      if (this.isArmSpecific) {
        const selectedArm = this.armList.find(
          a => a.ArmCode === this.values.armCode
        );

        if (selectedArm?.SoAId) {
          params.soaId = selectedArm.SoAId;
        } else if (this.values.armCode) {
          params.armCode = this.values.armCode;
        }

        return params;
      }

      // NON ARM SPECIFIC STUDY

      //  Cohort SoA
      const selectedCohort = this.cohortList.find(
        c => c.id === this.values.cohortId
      );

      if (selectedCohort?.soAId) {
        params.soaId = selectedCohort.soAId;
        return params;
      }

      // Arm SoA (fallback even if not arm-specific)
      const selectedArm = this.armList.find(
        a => a.ArmCode === this.values.armCode
      );

      if (selectedArm?.SoAId) {
        params.soaId = selectedArm.SoAId;
        return params;
      }

      //  Study SoA
      if (this.studySoAId) {
        params.soaId = this.studySoAId;
        return params;
      }

      //  Existing workflow (no SoA → backend decides)
      return params;
    }


  },

};

